import moment from 'moment';
import { mapTimeRangeToInteger, getClaimProduct } from 'src/utils/claim';
/**
 * @typedef {{
 
 * }} Claim
 */

/**
 * @param {Claim} claim
 * @param {{status: string[], disposition: string[], timeRange: string[], keyWords: string[]}} filterCriteria
 * @return {Claim & {keyWordCount: number}}
 */
export default function countKeyWordsInClaim(claim, filterCriteria) {
  let keyWordCount = 0;
  let foundFilterMatches = true;

  if (filterCriteria?.status?.length > 0) {
    const { claimStatus } = claim;
    if (filterCriteria.status.indexOf(claimStatus) >= 0) {
      keyWordCount++;
    } else {
      foundFilterMatches = false;
    }
  }
  if (filterCriteria?.disposition?.length > 0) {
    if (filterCriteria.disposition.indexOf(claim.currentDisposition) >= 0) {
      keyWordCount++;
    } else {
      foundFilterMatches = false;
    }
  }
  if (filterCriteria?.timeRange?.length > 0) {
    const today = moment();
    const claimUpdateDate = moment(claim.lastUpdateDate);
    const differenceInDays = today.diff(claimUpdateDate, 'days');
    const timeRangeValue = mapTimeRangeToInteger(filterCriteria.timeRange[0]);

    switch (timeRangeValue) {
      case 0:
      case 1:
        // Today and Yesterday
        if (differenceInDays === timeRangeValue) {
          keyWordCount++;
        } else {
          foundFilterMatches = false;
        }
        break;
      case 7:
      case 30:
      case 60:
      case 90:
        // Last 7, 30, 60, 90 days
        if (differenceInDays <= timeRangeValue) {
          keyWordCount++;
        } else {
          foundFilterMatches = false;
        }
        break;
      default:
        // All time
        keyWordCount++;
        break;
    }
  }

  const {
    count,
    foundKeyWordMatches
  } = countKeyWordMatches(claim, filterCriteria.keyWords)
  keyWordCount += count;

  if (!(foundFilterMatches && foundKeyWordMatches)) {
    keyWordCount = 0;
  }

  return { ...claim, keyWordCount };
}

/**
 * @param {Claim} claim 
 * @param {string[]} keyWordList 
 * @return {{foundKeyWordMatches: boolean, count: number}}
 */
function countKeyWordMatches(claim, keyWordList) {
  let foundKeyWordMatches = false;
  let count = 0;

  if (!keyWordList) {
    return { foundKeyWordMatches, count };
  }

  if (keyWordList.length === 0) {
    foundKeyWordMatches = true;
  }

  keyWordList.forEach(searchText => {
    const keyWord = searchText.toLowerCase().trim();
    if (fieldIncludesKeyWord(claim.claimantName, keyWord)) {
      count++;
      foundKeyWordMatches = true;
    }
    if (fieldIncludesKeyWord(claim.dealerName, keyWord)) {
      count++;
      foundKeyWordMatches = true;
    }
    if (fieldIncludesKeyWord(claim.trackingNumber, keyWord)) {
      count++;
      foundKeyWordMatches = true;
    }
    if (fieldIncludesKeyWord(`${claim.claimId}`, keyWord)) {
      count++;
      foundKeyWordMatches = true;
    }
    if (fieldIncludesKeyWord(claim.vendorPurchaseOrder, keyWord)) {
      count++;
      foundKeyWordMatches = true;
    }
    if (fieldIncludesKeyWord(claim.orderMasterControlNumber, keyWord)) {
      count++;
      foundKeyWordMatches = true;
    }
    if (fieldIncludesKeyWord(claim.disablementDescription, keyWord)) {
      count++;
      foundKeyWordMatches = true;
    }

  });

  return { foundKeyWordMatches, count };
}

/**
 * @param {any} field 
 * @param {string} keyWord 
 * @returns {boolean}
 */
function fieldIncludesKeyWord(field, keyWord) {
  if (field == undefined) {
    return false;
  }

  return `${field}`.toLowerCase().includes(keyWord);
}
